import { Button } from '@mui/material';
import FormProvider from '@Components/hook-form';

import { AtLocator } from '@Components/shared/locators/AtLocator';

import { CreateDialogFooterLayout } from '@Components/shared/layouts/CreateDialogFooterLayout';
import { CreateDialogLayout } from '@Components/shared/layouts/CreateDialogLayout';

import { AddRolePermissionsContent } from './AddRolePermissionsContent';

import { useAddRolePermissionsForm } from '@Forms/aviatorPermissions/AddRolePermissionsFormContext';
import { useAviatorPermissions } from '@Modal/hooks/aviatorRoles/useAviatorPermissions';

export const AddRolePermissionsForm = () => {
  const methods = useAddRolePermissionsForm();
  const {
    handleCloseAddRolePermissionsForm,
    addRolePermissionsSubmittable,
    handleSubmitAddRolePermissions,
  } = useAviatorPermissions();

  return (
    <FormProvider methods={methods}>
      <CreateDialogLayout>
        <AddRolePermissionsContent />
        <CreateDialogFooterLayout>
          <AtLocator type="button" name="Cancel">
            <Button variant="outlined" color="inherit" onClick={handleCloseAddRolePermissionsForm}>
              Cancel
            </Button>
          </AtLocator>
          <AtLocator type="button" name="Submit">
            <Button
              type="submit"
              variant="contained"
              disabled={!addRolePermissionsSubmittable}
              onClick={handleSubmitAddRolePermissions}
            >
              Confirm
            </Button>
          </AtLocator>
        </CreateDialogFooterLayout>
      </CreateDialogLayout>
    </FormProvider>
  );
};
